import axios from "../lib/axios";

export const createContact = async (data) => {
  try {
    const response = await axios.post("/contact", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create category"
    );
  }
};

export const getAllCategories = async () => {
  try {
    const response = await axios.get("/contact");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch categories"
    );
  }
};
